"use client"
import { t } from "@/translations"
import { LowestPrice } from "@/types/centra/checkout-api/payment/payment-reciept"
import React from "react"
import InformationIcon from "../../Atoms/Icons/InformationIcon"
import Text from "../../Atoms/Text"
import Tooltip from "../../Molecules/Tooltip"

interface PriceProps {
    showAsOnSale: boolean
    productPrice: string
    priceBeforeDiscount: string
    lowestPrice: LowestPrice[]
    langCode: string
}

const Price: React.FC<PriceProps> = ({
    showAsOnSale,
    productPrice,
    priceBeforeDiscount,
    lowestPrice,
    langCode
}) => {
    return showAsOnSale ? (
        <div className="flex items-center gap-8">
            <Text size="medium" weight="regular">
                {productPrice}
            </Text>{" "}
            <Text
                size="medium"
                weight="regular"
                className="text-main-dark-grey line-through"
            >
                {priceBeforeDiscount}
            </Text>
            <Tooltip
                tooltipOriginX="center"
                tooltipOriginY="bottom"
                tooltipContent={
                    <>
                        <div>
                            {t(langCode, "product_page.current_price", {
                                price: productPrice || lowestPrice?.[0]?.price
                            })}
                        </div>
                        <div>
                            {t(langCode, "product_page.lowest_price", {
                                lowestPrice: lowestPrice?.[0]?.price
                            })}
                        </div>
                        <div>
                            {t(langCode, "product_page.original_price", {
                                originalPrice: lowestPrice?.[0]?.priceBeforeDiscount
                            })}
                        </div>
                    </>
                }
            >
                <InformationIcon className="ml-2 cursor-pointer opacity-50" />
            </Tooltip>
        </div>
    ) : (
        <Text size="medium" weight="regular">
            {productPrice}
        </Text>
    )
}

export default Price
